import api from 'app/shared/utils/api';

import appLogger from 'app/shared/loggers/appLogger';

import DispatchConstants from 'app/shared/constants/DispatchConstants';
import LeadsAll from 'app/shared/model/LeadsAll';
import LeadsDetails from 'app/shared/model/LeadsDetails';
import LeadCountsForListing from 'app/shared/model/LeadCountsForListing';

const LeadActions = {
    getAllLeads(params = {}, appendToAllLeads = false) {
        return dispatch => dispatch(api.users.leads.allLeads(params))
            .then((result) => {
                if (result.success) {
                    const leadsAllModel = LeadsAll(result.response);
                    const payload = {
                        appendToAllLeads,
                        leadsAllModel,
                    };

                    return dispatch({
                        type: DispatchConstants.LEAD_ALL_LEADS_SUCCESS,
                        payload,
                    });
                }
                return Promise.reject(result.error);
            });
    },
    getLead(params = {}) {
        return dispatch => dispatch(api.users.leads.lead(params))
            .then((result) => {
                if (result.success) {
                    const leadsDetailsModel = LeadsDetails(result.response);

                    return dispatch({
                        type: DispatchConstants.LEAD_SUCCESS,
                        payload: leadsDetailsModel,
                    });
                }

                throw new Error({
                    message: 'message',
                });
            })
            .catch((err) => {
                dispatch({
                    type: DispatchConstants.LEAD_FAIL,
                    payload: err,
                });
                return Promise.reject(err);
            });
    },
    updateLeadStatus(params = {}) {
        return dispatch => dispatch(api.users.leads.updateLeadStatus(params))
            .then((result) => {
                if (result.success) {
                    return result.response;
                }
                return Promise.reject(result.error);
            })
            .catch(err => new Error(err));
    },
    getConversationCountsForListing(params = {}) {
        return dispatch => dispatch(api.users.leads.getConversationCountsForListing(params))
            .then((result) => {
                if (result.success) {
                    return LeadCountsForListing(result.response);
                }
                return Promise.reject(result.error);
            })
            .catch((errorRMWModel) => {
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'LeadActions.getConversationCountsForListing',
                });

                return Promise.reject(errorRMWModel);
            });
    },
};

export default LeadActions;
